import { render, staticRenderFns } from "./Notesdetails.vue?vue&type=template&id=5174d142"
import script from "./Notesdetails.vue?vue&type=script&lang=js"
export * from "./Notesdetails.vue?vue&type=script&lang=js"
import style0 from "./Notesdetails.vue?vue&type=style&index=0&id=5174d142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports